import { NgModule } from '@angular/core';
import { MagnifyDirective } from '@app/shared/directives/magnify/magnify.directive';

@NgModule({
  exports: [MagnifyDirective],
  declarations: [MagnifyDirective]
})
export class MagnifyModule {}
